// src/pages/PagesUtilisateurs/DashboardUsers/ui/DashboardActionButton.jsx

import React from "react";

const VARIANTS = {
  neutral:
    "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-950 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white",

  primary:
    "border-blue-200 bg-blue-50 text-[#013E8E] hover:border-blue-300 hover:bg-blue-100 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300 dark:hover:bg-blue-500/20",

  danger:
    "border-rose-200 bg-white text-rose-600 hover:bg-rose-50 dark:border-rose-500/20 dark:bg-slate-900 dark:text-rose-300 dark:hover:bg-rose-500/10",

  success:
    "border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
};

export default function DashboardActionButton({
  icon: Icon,
  children,
  onClick,
  variant = "neutral",
  title,
  disabled = false,
  compact = false,
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center gap-2
        rounded-xl border font-bold
        transition
        focus:outline-none focus:ring-2 focus:ring-blue-200
        disabled:pointer-events-none disabled:opacity-40
        ${
          compact
            ? "h-9 w-9 p-0 text-xs"
            : "px-3 py-2 text-xs"
        }
        ${VARIANTS[variant] || VARIANTS.neutral}
        ${className}
      `}
    >
      {Icon ? <Icon /> : null}

      {!compact ? children : null}
    </button>
  );
}